import { render, staticRenderFns } from "./EmploymentForm.vue?vue&type=template&id=153f6200&scoped=true&"
import script from "./EmploymentForm.vue?vue&type=script&lang=js&"
export * from "./EmploymentForm.vue?vue&type=script&lang=js&"
import style0 from "./EmploymentForm.vue?vue&type=style&index=0&id=153f6200&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153f6200",
  null
  
)

export default component.exports